/**
 * 付款頁「跨流程返回點」工具。
 *
 * 使用情境：未註冊客戶掃付款 QR（`/pay/{orderId}?invite_code=XXXXXX`），會被導去
 * 註冊 + 加入家庭（JoinRegister）流程，完成後要回到原本的付款頁繼續付款，
 * 而不是掉回首頁。進站時把付款頁路徑存進 sessionStorage，JoinSuccess 完成時讀出。
 *
 * 僅接受 `/pay/` 開頭的路徑（set/get 都檢查），避免這個攜帶機制被誤用去導去其他頁面。
 */
const KEY = "pay_return_to";

const isPayPath = (path: string): boolean => /^\/pay\//.test(path);

/** 進站時呼叫：記下要返回的付款頁路徑（僅接受 /pay/ 開頭）。 */
export const setPayReturnTo = (path: string): void => {
  if (typeof window === "undefined") return;
  if (!isPayPath(path)) return; // 僅付款頁，避免污染其他流程
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // 忽略：存不進去就當作沒有 returnTo
  }
};

/** 取得先前記下的付款頁返回路徑；沒有或不合法則 null。 */
export const getPayReturnTo = (): string | null => {
  if (typeof window === "undefined") return null;
  const v = sessionStorage.getItem(KEY);
  return v && isPayPath(v) ? v : null;
};

/** 用掉/離開後清除，避免殘留影響後續流程。 */
export const clearPayReturnTo = (): void => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(KEY);
};
